import styled, { keyframes } from "styled-components";

const defaultAnimation = keyframes`
  0% {
    opacity: 0;
    height: 100vh;
  }

  50% {
    opacity: 1;
    height: 100vh;
  }

  75% {
    height: 100vh;
  }

  100% {
    opacity: 1;
    height: 10rem;
  }
`;

export const InitialContainer = styled.div`
  width: 100vw;
  height: 100vh;
  background-color: #242424;
  overflow-y: hidden;

  transition: 1s ease;

  .titleContainer {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;

    color: rgba(255, 255, 255, 0.85);
    font-size: 1.5rem;
    user-select: none;

    animation: ${defaultAnimation} 5s forwards ease;
  }

  .terminalContainer {
    width: 100%;
    height: 85vh;
    margin-top: -1vh;
    display: flex;
    align-items: center;
    justify-content: center;
  }
`;

export const Terminal = styled.div`
  background-color: rgba(0, 0, 0, 1);
  border-radius: 15px;
  width: 50%;
  height: 75%;
  box-shadow: rgba(0, 0, 0, 1) 0 0 10px -2.5px;
  padding: 2.5rem 2rem;
  color: rgba(255, 255, 255, 0.85);
  font-size: 1.5rem;
`;

export const Command = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;

  .fixArrange {
    display: flex;
    gap: 1rem;
    width: 100%;
    align-items: center;
  }
`;

const mainContainerFadeIn = keyframes`
  from {opacity: 0}
  to {opacity: 1}
`;

export const MainContainer = styled.div`
  width: 100%;
  min-height: 100vh;
  display: flex;
  justify-content: center;
  padding: 2rem;

  animation: ${mainContainerFadeIn} 3s ease;

  .content {
    color: rgba(255, 255, 255, 0.85);
    padding: 2rem;

    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;

    .cardsContainer {
      display: flex;
      width: 100%;
      height: 100%;
      align-items: center;
      justify-content: center;
    }

    #title {
      font-size: 3rem;
    }
  }
`;
